import { render, staticRenderFns } from "./ListAutorizados.vue?vue&type=template&id=02704f8e&"
import script from "./ListAutorizados.vue?vue&type=script&lang=js&"
export * from "./ListAutorizados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports